<template>
	<div>
		<slot v-if="hasArgs" name="form">
			<div v-for="(value, name) in argDescriptions" :key="name">
				<k4-model-value-field
					v-model="args[name]"
					:node="node"
					:subpath="`${metaSubpath.join('/')}/${name}`"
					@input="$emit('input', args)"
				/>
			</div>
		</slot>
		<slot v-else name="empty"></slot>
	</div>
</template>

<script>
import _ from "lodash";

export default {
	props: {
		node: {
			type: Object,
		},
		subpath: {
			type: String,
		},
		args: {
			type: Object,
			required: true,
		},
	},

	computed: {
		metaSubpath() {
			if (!this.node || !this.subpath) return [];
			return ["meta", ...this.subpath.split("/"), "args"];
		},

		argDescriptions() {
			return _.get(this.node, this.metaSubpath, {});
		},

		hasArgs() {
			return !_.isEmpty(this.argDescriptions);
		},
	},
};
</script>
